var Chaplin, EmailModel, EmailPopupView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/email-popup');

View = require('views/base/view');

Chaplin = require('chaplin');

EmailModel = require('models/email');

module.exports = EmailPopupView = (function(_super) {
  __extends(EmailPopupView, _super);

  function EmailPopupView() {
    _ref = EmailPopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  EmailPopupView.prototype.template = template;

  EmailPopupView.prototype.className = 'popup';

  EmailPopupView.prototype.tagName = 'div';

  EmailPopupView.prototype.id = 'email-popup';

  EmailPopupView.prototype.autoRender = true;

  EmailPopupView.prototype.container = 'body';

  EmailPopupView.prototype.listen = {
    'sentSuccess model': 'showSuccessMessage'
  };

  EmailPopupView.prototype.events = {
    'click .btn-close': 'closePopup',
    'submit form': 'send'
  };

  EmailPopupView.prototype.initialize = function() {
    var info;
    EmailPopupView.__super__.initialize.apply(this, arguments);
    info = Chaplin.mediator.catalogue.get('info');
    return this.model = new EmailModel({
      catalogueFolder: info.folder,
      catalogueName: info.name
    });
  };

  EmailPopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  EmailPopupView.prototype.send = function(e) {
    var serializedData,
      _this = this;
    serializedData = this.$('#email-form').serializeObject();
    this.model.set(serializedData);
    this.publishEvent('catalogue:getActivePage', function(activePages) {
      _this.model.set({
        pageNum: activePages[0] || activePages[1]
      });
      return _this.model.save();
    });
    return false;
  };

  EmailPopupView.prototype.showSuccessMessage = function() {
    this.$('.success-message').fadeIn();
    return this.$('.popup-form').hide();
  };

  return EmailPopupView;

})(View);
